import './OverViewHero.scss';

import React from 'react';
import { Image, RichText } from '@sitecore-jss/sitecore-jss-react';

export default function OverViewHero({ fields }) {
  return (
    <div className={'container over-view-hero'}>
      <div className={'wrapper'}>
        <div className={'image'}>
          <Image alt={'HeroImage'} fill field={fields.image} />
        </div>
        <div className={'mobileImage'}>
          <Image alt={'HeroImage'} fill field={fields.mobileImage} />
        </div>
        <div>
          <h1 className={'title'} data-aos="fade-up" data-aos-offset="100">
            {/* <strong>Channel</strong> overview */}
            <RichText field={fields.titleRichText} />
          </h1>
          <p className={'text'} data-aos="fade-up" data-aos-offset="150">
            {fields.desc?.value}
          </p>
        </div>
      </div>
    </div>
  );
}
